module.exports = __webpack_public_path__ + "05_bob_black.eb049ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/05_bob_black.png
// module id = ooRF
// module chunks = 0